import BaseBehavior from '../../../framework/base/base';
import { whenInView } from '../../../shared/utilities/when-in-view';

export default class Article extends BaseBehavior {
	constructor(element) {
		super(element);
		this.initDomCache();
		// tracking when article page is in visible viewport
		whenInView(element).then(() => {
			this.track();
		});
	}

	track() {
		if (window.adobeDataLayer) {
			const jsonld = JSON.parse(this.dom.info.textContent);
			const componentViewed = {
				componentInfo: {
					componentId: '', // LIST id of component
					componentType: 'articleInfo'
				},
				measures: {
					impression: '1' // since component is in view already
				},
				articleInfo: {
					articleAuthor: jsonld.author,
					articleTopics: jsonld.topics,
					articleHeadline: jsonld.headline,
					articleKeyword: jsonld.keyword,
					articlePublished: jsonld.published.split('T')[0],
					articleTopicKeyword: jsonld.topics
				}
			};
			window.adobeDataLayer.push({ event: 'componentViewed', ...componentViewed });
		}
	}
}
